//urls
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const RELATIVE_URL= process.env.REACT_APP_RELATIVE_URL;

export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;
//STARI ADMIN
// export const ADMIN_LOGIN_URL = ADMIN_URL + "/authorization/hibridnaEntrypoint";
// export const ADMIN_LOGOUT_URL = ADMIN_URL + "/authorization/hibridnaExitpoint";

//NOVI ADMIN
export const ADMIN_LOGIN_URL = ADMIN_URL + "/api/nias/receive-authentication-response";
export const ADMIN_LOGOUT_URL = ADMIN_URL + "/#/end";

export const AREP_URL = process.env.REACT_APP_AREP_URL;
export const AREP_LOGIN_URL = AREP_URL + "/api/nias/receive-authentication-response";
export const AREP_LOGOUT_URL = AREP_URL + "/#/end";

export const POB_URL = process.env.REACT_APP_POB_URL;
export const POB_LOGIN_URL = POB_URL + "/api/nias/receive-authentication-response";
export const POB_LOGOUT_URL = POB_URL + "/#/end";

export const GOV_HR_URL = "https://gov.hr/";

//auth reducers
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
export const CHANGE_SUBJECT = "CHANGE_SUBJECT";
export const AUTHORITIES = "AUTHORITIES";


export const initState = {
    pending:false,
    userData:null,
    isAuthenticated:false,
    error:false,
    host:"",
    initialRoles:undefined,
    subjectData:{
        forLegalIps:"null",
        forLegalIzvor:"null",
        forPersonOib:"null",
        toLegalIps:"null",
        toLegalIzvor:"null",
    },
}

//UI
export const VERSION = process.env.REACT_APP_VERSION;
export const DISABILITY = "DISABILITY";
export const DYSLEXIA = "DYSLEXIA";
export const FONT_SIZE_CHANGED = "FONT_SIZE_CHANGED";
export const FOREIGN_USER = "identifikator stranca";

